import { API_ENDPOINTS } from '@/constants/api';
import { useEntityForm } from '@/shared/hooks/useEntityForm';
import type { CreateUserData, User } from '@/shared/types/user';
import { usersApi } from '../api';
import { createUser, updateUser } from '../store/entitySlice';

export const useUserForm = () => {
  return useEntityForm<User, CreateUserData>({
    api: usersApi,
    createAction: createUser,
    updateAction: updateUser,
    listEndpoint: API_ENDPOINTS.USERS.LIST,
    entityName: 'User',
  });
};
